
import { defineComponent, ref, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { Actions } from "@/store/enums/StoreEnums"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import { Loading } from '@element-plus/icons-vue'
import { MatchPool, MatchPoolStats } from "@/store/modules/MatchPoolModule"

export default defineComponent({
  components: {
    Loading
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const poolId = Number(route.params.id)
    const loading = ref(true)
    const pool = ref<MatchPool | null>(null)
    const stats = ref<MatchPoolStats>({
      total_games: 0,
      total_revenue: 0,
      total_cost: 0,
      actual_profit: 0,
      actual_profit_rate: 0,
      match_count_distribution: []
    })

    onMounted(async () => {
      setCurrentPageBreadcrumbs("池子统计", ["对对碰系统", "池子管理;match_pools"])

      try {
        // 加载池子信息
        await store.dispatch(Actions.GET_MATCH_POOL, poolId)
        pool.value = store.getters.currentMatchPool

        // 加载统计数据
        await store.dispatch(Actions.GET_MATCH_POOL_STATS, poolId)
        stats.value = store.getters.currentMatchPoolStats
      } catch (error) {
        ElMessage.error('加载数据失败')
      } finally {
        loading.value = false
      }
    })

    const totalRevenueYuan = computed(() => {
      return Number(stats.value.total_revenue || 0).toFixed(2)
    })

    const totalCostYuan = computed(() => {
      return Number(stats.value.total_cost || 0).toFixed(2)
    })

    const profitYuan = computed(() => {
      return Number(stats.value.actual_profit || 0).toFixed(2)
    })

    const profitRatePercent = computed(() => {
      return ((stats.value.actual_profit_rate || 0) * 100).toFixed(2)
    })

    const getMatchCountTagType = (matchCount: number) => {
      if (matchCount === 0) return 'info'
      if (matchCount >= 9) return 'danger'
      if (matchCount >= 5) return 'warning'
      return 'success'
    }

    const getProgressColor = (percentage: number) => {
      if (percentage >= 30) return '#F56C6C'
      if (percentage >= 15) return '#E6A23C'
      return '#67C23A'
    }

    const goBack = () => {
      router.push({ name: 'match_pools' })
    }

    return {
      poolId,
      loading,
      pool,
      stats,
      totalRevenueYuan,
      totalCostYuan,
      profitYuan,
      profitRatePercent,
      getMatchCountTagType,
      getProgressColor,
      goBack
    }
  }
})
